import merge from 'lodash/merge'
import type { PlayerRoster } from '~/types'

export const useLoadPlayerRostersById = (id: number, params: PlayerRoster.SearchRequest = {}) => {
  const { search } = usePlayerRosterApi()
  const isLoading = ref<boolean>(false)

  const { handleException } = useHandleException()

  const fetchData = async (): Promise<PlayerRoster.Model[]> => {
    isLoading.value = true
    try {
      const requestParams: PlayerRoster.SearchRequest = merge(params, {
        filter: {
          player_id: id,
        },
      })

      const { data } = await search(requestParams)

      return data
    }
    catch (ex: unknown) {
      handleException(ex)

      throw ex
    }
    finally {
      isLoading.value = false
    }
  }

  return {
    isLoading,

    fetchData,
  }
}
